// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Amount from '../../components/Amount/Amount';
import Account from '../../ressources/images/icons/Account.svg';
import Beneficiary from '../../ressources/images/icons/Titulaire.svg';
import InitiatingParty from '../../ressources/images/role/document@3x.png';
import { formatIBAN } from "../../utils/IBANUtils";
import './index.less';

const PaymentSummary = (props) => {

   const { paymentInfo } = props;

   const CANCELATION_STATE = 'CANCELLATION_SCA_REQUIRED';
   const state = paymentInfo.state;

   return (
      <div className="BILBox-summary-container">
         <div className="BILBox-summary-head__title">
            {
               CANCELATION_STATE === state ?
                  <FormattedMessage id="summary.cancelation.title" />
                  :
                  <FormattedMessage id="summary.confirmation.title" />
            }
         </div>

         <div className="BILBox-selection-item__summary">
            <FormattedMessage id={"summary.title"} />
         </div>

         <div className="BILBox-container" name="debtor_summary">
            <div className="BILBox-selection-item__title" >
               <FormattedMessage id={"summary.debtor.title"} />
            </div>

            <div className="BILBox-selection-item" >
               <img
                  src={Account}
                  className="BILBox-selection-item__avatar"
                  alt={"Debtor account"}
               />
               <div className="BILBox-selection-item__container" >
                  {
                     paymentInfo.debtorIban ?
                        <div>
                           <div className="BILBox-selection-item__name__uppercase">
                              <FormattedMessage id={"summary.debtor.account-selected-default-label"} />
                           </div>
                           <div className="BILBox-selection-item__value" >
                              {formatIBAN(paymentInfo.debtorIban)}
                           </div>
                        </div>
                        :
                        <div className="BILBox-selection-item__name">
                           <FormattedMessage id={"summary.debtor.no-account-selected"} />
                        </div>
                  }
               </div>
            </div>
         </div>

         <div className="BILBox-container" name="creditor_summary">
            <div className="BILBox-selection-item__title" >
               <FormattedMessage id={"summary.creditor.title"} />
            </div>

            <div className="BILBox-selection-item" >
               <img
                  alt={"Creditor Account Number"}
                  src={Beneficiary}
                  className="BILBox-selection-item__avatar"
               />
               <div className="BILBox-selection-item__container" >
                  {
                     <div>
                        <div className="BILBox-selection-item__name__uppercase">
                           {paymentInfo.creditorName}
                        </div>
                        <div className="BILBox-selection-item__value" >
                           {formatIBAN(paymentInfo.creditorIban)}
                        </div>
                     </div>
                  }
               </div>
            </div>
         </div>

         <div className="BILBox-container" name="initiating-party-summary">
            <div className="BILBox-selection-item__title" >
               <FormattedMessage id={"summary.initiationParty.title"} />
            </div>

            <div className="BILBox-selection-item" >
               <img
                  alt={"Initiating Party"}
                  src={InitiatingParty}
                  className="BILBox-selection-item__avatar"
               />
               <div className="BILBox-selection-item__container" >
                  {
                     <div>
                        <div className="BILBox-selection-item__name__uppercase">
                           {paymentInfo.initiatingParty}
                        </div>
                        <div className="BILBox-selection-item__value" >
                           <FormattedMessage id={"summary.initiationParty.subTitle"} />
                        </div>
                     </div>
                  }
               </div>
            </div>
         </div>

         <div className="BILBox-container" name="amount_summary">
            <div className="BILBox-selection-item__title" >
               <FormattedMessage id={"summary.amount.title"} />
            </div>

            <div className="BILBox-selection-item" >
               <div className="BILBox-selection-item__text">
                  <Amount balance={paymentInfo.amount} currency={paymentInfo.currency} color={'black'} context={'summary'} />
               </div>
            </div>
         </div>

         <div className="BILBox-container" name="transfer_type_summary">
            <div className="BILBox-selection-item__title" >
               <FormattedMessage id={"summary.transfer.title"} />
            </div>

            <div className="BILBox-selection-item" >
               <div className="BILBox-selection-item__text">
                  {
                     paymentInfo.transferType === "ORDER" ? <FormattedMessage id={"summary.transfer.standard"} /> : 
                     paymentInfo.transferType === "STANDING_ORDER" ? <FormattedMessage id={"summary.transfer.sto"} /> : null
                  }
               </div>
            </div>
         </div>
         {
            paymentInfo.transferType !== "STANDING_ORDER" ?
               <div>
                  <div className="BILBox-container" name="execution_date_summary">
                     <div className="BILBox-selection-item__title" >
                        <FormattedMessage id={"summary.execution-date.title"} />
                     </div>

                     <div className="BILBox-selection-item" >
                        <div className="BILBox-selection-item__text">
                           {paymentInfo.executionDate}
                        </div>
                     </div>
                  </div>
               </div>
               :
               <div>
                  <div className="BILBox-container" name="execution_date_summary">
                     <div className="BILBox-selection-item__title" >
                        <FormattedMessage id={"summary.start-date.title"} />
                     </div>

                     <div className="BILBox-selection-item" >
                        <div className="BILBox-selection-item__text">
                           {paymentInfo.executionDate}
                        </div>
                     </div>
                  </div>

                  <div className="BILBox-container" name="end_date_summary">
                     <div className="BILBox-selection-item__title" >
                        <FormattedMessage id={"summary.end-date.title"} />
                     </div>

                     <div className="BILBox-selection-item" >
                        <div className="BILBox-selection-item__text">
                           {paymentInfo.endDate}
                        </div>
                     </div>
                  </div>

                  <div className="BILBox-container" name="frequency_summary">
                     <div className="BILBox-selection-item__title" >
                        <FormattedMessage id={"summary.frequency-date.title"} />
                     </div>

                     <div className="BILBox-selection-item" >
                        <div className="BILBox-selection-item__text">
                           {paymentInfo.frequency}
                        </div>
                     </div>
                  </div>
               </div>
         }
         <div className="BILBox-container" name="message_summary">
            <div className="BILBox-selection-item__title" >
               <FormattedMessage id={"summary.message.title"} />
            </div>

            <div className="BILBox-selection-item" >
               <div className="BILBox-selection-item__text">
                  {paymentInfo.remittanceInformation}
               </div>
            </div>
         </div>
      </div>
   )
}
export default (PaymentSummary);